import { createStyles } from 'antd-style';

import { ThemeSpaces } from '../../../theme';

export const usePackageListPackageEditingModeStyles = createStyles(() => ({
  newShipmentPackagePrevTabsInfo: {
    padding: `${ThemeSpaces.SPACE_NORM0_5}px ${ThemeSpaces.SPACE_NORM}px`,

    '.NewShipmentPackage-Header &': {
      padding: 0,
    },
  },
}));
